module.exports = __webpack_public_path__ + "media/images/lb/307-855265eeb9742d9b6861fe326871a780.svg";